// extracted by mini-css-extract-plugin
export default {"LoadError":"bey_a bhl_qq bhl_a bhl_w bhl_j bhl_q","LoadError__icon":"bey_b bhl_vj bhl_fk bhl_su","LoadError__message":"bey_c bhl_fk bhl_tp"};